import { BUILD_NUMBER, ENVIRONMENT_NAME } from '../../redux/constants';

const getSsrUserAgent = () => {
  if (typeof window !== 'undefined') return window.navigator.userAgent;
  return `Showcase SSR / (${BUILD_NUMBER}), ${ENVIRONMENT_NAME}`;
};

export default getSsrUserAgent;
